import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const salesCounterContent = {
  // El número varía entre estos valores cada día (mismo número para todos los visitantes en el mismo día)
  minSales: 10,
  maxSales: 50,
  // Texto que aparece junto al número. Usá {count} como variable para el número.
  message: 'profesionales compraron el MegaPack hoy',
  liveLabel: 'EN VIVO'
};
// Genera un número pseudo-aleatorio estable basado en la fecha (día/mes/año)
function getDailySalesCount(min: number, max: number): number {
  const today = new Date();
  const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
  // Hash simple para distribuir
  const pseudo = Math.abs(Math.sin(seed) * 10000);
  const fraction = pseudo - Math.floor(pseudo);
  return Math.floor(fraction * (max - min + 1)) + min;
}
export function SalesCounter() {
  const [count, setCount] = useState(() => getDailySalesCount(salesCounterContent.minSales, salesCounterContent.maxSales));
  const [bump, setBump] = useState(0);
  useEffect(() => {
    // Pequeños "bumps" visuales cada cierto tiempo para dar sensación de actividad en vivo
    const interval = setInterval(() => {
      setBump(b => b + 1);
    }, 12000);
    return () => clearInterval(interval);
  }, []);
  // Cada bump suma 1 al contador mostrado (sin pasar del max)
  useEffect(() => {
    if (bump === 0) return;
    setCount(c => c < salesCounterContent.maxSales ? c + 1 : c);
  }, [bump]);
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-red-950 via-brand-accent to-red-950 border-b border-red-800/50 shadow-lg" data-id="element-183">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-white" data-id="element-184">
        <span className="relative flex h-2.5 w-2.5 shrink-0" data-id="element-185">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-300 opacity-75" data-id="element-186" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-200" data-id="element-187" />
        </span>

        <span className="text-[10px] md:text-xs font-bold tracking-widest text-red-200 hidden sm:inline" data-id="element-188">
          {salesCounterContent.liveLabel}
        </span>

        <Flame className="w-4 h-4 text-yellow-300 shrink-0" data-id="element-189" />

        <p className="text-xs md:text-sm font-sans text-center" data-id="element-190">
          <AnimatePresence mode="popLayout" data-id="element-191">
            <motion.span key={count} initial={{
            y: -10,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} exit={{
            y: 10,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="inline-block font-bold text-white text-base md:text-lg mx-1" data-id="element-192">
              {count}
            </motion.span>
          </AnimatePresence>
          {salesCounterContent.message}
        </p>
      </div>
    </div>;
}